
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/post-checkout",
      function () {
        return require("private-next-pages/shopping/post-checkout.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping/post-checkout"])
      });
    }
  